<template>

<div class="myheader row" v-show="mydata.header">

 <div class="col-2 tleft">
 <transition name="fade">
  	<mt-button class="fa fa-bars left" @click.native="leftnav()"  v-show="!mydata.back"></mt-button>
 </transition> 	
<transition name="fade">
  	<mt-button class="fa fa-angle-left back" v-show="mydata.back" @click="myback()"></mt-button>
 </transition> 	
 </div>

 <div class="col-6 title" @click="top()">
  <router-link to="/" v-show="mydata.nav=='/'">
  	<img src="../images/logo.png" alt="第一健康" class="logo">
  </router-link> 

  <span v-show="mydata.nav!='/'" class="header_title">{{mydata.nav}}</span>
 </div>

 <div class="col-2 tright">
  <router-link to="/user/index">
  	<mt-button class="fa fa-user-o right"></mt-button>
  </router-link>
 </div>

</div>

</template>

<style scoped>
.tleft{text-align: left;}
.tright{text-align: right;}
</style>

<script>

export default {
	data:function(){
		return {
           mydata:mydata,
           doback:fun.doback,
		}
	},
	methods:{
      leftnav:function(){
      	this.mydata.navshow=!this.mydata.navshow;
      },
      myback:function(){
        fun.doback();
      	this.$emit("doback");
      },
      top:function(){
        window.scrollTo(0,0);
      }
	}
}	
</script>


// WEBPACK FOOTER //
// src/lib/myheader.vue